import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/7.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Kantorat"
            question="Co cię najbardziej interesuje?"
            audio={audio}
            answers={{
                ans1: "Gdzie jest Tarszewo?",
                ans2: "Skąd te zdobione bramy?",
                ans3: "Co to za rzekę widać ze wzgórza?"
            }}
            links={{
                link1: PAGES.p16,
                link2: PAGES.p17,
                link3: PAGES.p18
            }}
            content={
                <div>
                    <p>
                        Murowany kościół jest zamknięty na cztery spusty, podobnie jak budynek obok. Czyżby nikogo tu nie było? Dopiero w budynku na rogu widzisz otwarte okna. Ktoś musi być w środku! Pukasz w piękne drewniane drzwi z geometrycznym zdobieniem.
                    </p>
                    <ul>
                        <li>Proszę! – słyszysz męski głos i wchodzisz do środka.</li>
                        <li>Dzień dobry, szukam miejscowego kantora. Czy to pan? – pytasz.</li>
                        <li>Tak, tak, tak, zastępuję pastora Grossa, wyjechał… O, nowa twarz w Zagórowie, widzę… W czym mogę pomóc?</li>
                        <li>Szukam pracy, podobno pan mógłby mi pomóc. Tak mi powiedzieli.</li>
                        <li>
                            Ach, czyli interes! Pomogę, a jakże, pomogę… – odpowiada rumiany kantor. – Ale najpierw coś ci opowiem o naszym miasteczku… Co cię najbardziej interesuje?
                        </li>
                    </ul>
                </div>
            }
        />

    );
}